export default "__VITE_ASSET__JWgkaN1x__"